<template>
  <TransitionRoot
    :show="sheet.visible"
    as="template"
  >
    <Dialog @close="close">
      <DialogOverlay @click.self="close" />
      <TransitionChild
        as="template"
        enter="duration-200 ease-out"
        enter-from="translate-y-full sm:translate-y-0 sm:translate-x-full"
        enter-to="motion-reduce:transition-none translate-y-0 sm:translate-x-0"
        leave="duration-200 ease-in"
        leave-from="translate-y-0 sm:translate-y-0 sm:translate-x-full"
        leave-to="motion-reduce:transition-none translate-y-full sm:translate-y-0 sm:translate-x-full"
      >
        <DialogPanel class="fixed bottom-0 left-0 right-0 w-full sm:top-0 sm:left-auto sm:max-w-md z-20">
          <Component
            :is="content.component"
            v-if="content"
            v-bind="content.props"
            v-on="content?.events"
          />
        </DialogPanel>
      </TransitionChild>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, computed } from 'vue'
import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogPanel
} from '@headlessui/vue'
import DialogOverlay from '@/components/shared/v2/dialog-overlay.vue'
import { useThemeStore } from '@/stores'
const { sheet } = useThemeStore()
const { close } = sheet
const content = computed(() => sheet.content)
const handleSwipe = (e) => {
  if (e.target?.closest('.half-sheet-swipe-close')) {
    close()
  }
}
onMounted(() => {
  document.addEventListener('swiped-down', handleSwipe)
})
onBeforeUnmount(() => {
  document.removeEventListener('swiped-down', handleSwipe)
})
</script>
